import $ from "jquery";
import LoginButton from "./modules/login-button";
import Header from "./widgets/header"
import RegisterNew from "./widgets/register-new"
import Account from "./widgets/account"
import AccountSelectors from "./widgets/accountSelectors"
import NewHeader from "./widgets/new-header";
import domEvents from "./modules/dom-events";
import AccountSavedArticless from "./widgets/account-saved-articles";
import AccountSearchFavoriteArticles from "./widgets/account-search-favorite-articles";
import AccountCourses from "./widgets/account-courses";

new Header();
new NewHeader();
domEvents.init();

$('[data-login-show]').each(function(){
    new LoginButton(this);
});

document.addEventListener("DOMContentLoaded", function () {
    new RegisterNew($('[data-id="c-subscriptions-list"]'), $('[data-id="c-subscriptions-form"]'), $('[data-id="register-render"]'));
    new Account();
    $('[data-select]').each(function () {
        new AccountSelectors(this);
    })
});

$('[data-id="accountsavedarticles"]').each(function () {
    new AccountSavedArticless(this)
});

$('[data-id="searchFavoritesForm"]').each(function () {
    new AccountSearchFavoriteArticles(this)
});

$('[data-id="accountCourses"]').each(function () {
    new AccountCourses(this)
});